export default __webpack_public_path__ + "static/media/ads5.3dacb72f.png";